/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SaveOfRepostNotificationAction } from './SaveOfRepostNotificationAction';
import {
    SaveOfRepostNotificationActionFromJSON,
    SaveOfRepostNotificationActionFromJSONTyped,
    SaveOfRepostNotificationActionToJSON,
} from './SaveOfRepostNotificationAction';

/**
 * 
 * @export
 * @interface SaveOfRepostNotification
 */
export interface SaveOfRepostNotification {
    /**
     * 
     * @type {string}
     * @memberof SaveOfRepostNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SaveOfRepostNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveOfRepostNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof SaveOfRepostNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<SaveOfRepostNotificationAction>}
     * @memberof SaveOfRepostNotification
     */
    actions: Array<SaveOfRepostNotificationAction>;
}

/**
 * Check if a given object implements the SaveOfRepostNotification interface.
 */
export function instanceOfSaveOfRepostNotification(value: object): value is SaveOfRepostNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function SaveOfRepostNotificationFromJSON(json: any): SaveOfRepostNotification {
    return SaveOfRepostNotificationFromJSONTyped(json, false);
}

export function SaveOfRepostNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveOfRepostNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(SaveOfRepostNotificationActionFromJSON)),
    };
}

export function SaveOfRepostNotificationToJSON(value?: SaveOfRepostNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(SaveOfRepostNotificationActionToJSON)),
    };
}

